import { Professional, Location } from 'graphql/generated/graphql';
import { axios } from 'utils/networkRequests';

export const proPools = {
  actions: {
    invite: ({
      professionalId,
      locationId,
    }: {
      professionalId: Professional['id'];
      locationId: Location['id'];
    }) =>
      axios.post('/v3/facility/pool/professional', {
        id: professionalId,
        professional: { location_id: locationId },
      }),
    remove: ({
      professionalId,
      locationId,
    }: {
      professionalId: Professional['id'];
      locationId: Location['id'];
    }) =>
      axios.delete(`/v3/facility/pool/professional/${professionalId}`, {
        data: {
          professional: { location_id: locationId },
        },
      }),
  },
};
